module.exports = __webpack_public_path__ + "img/Frame 107.ea7fa663.png";